import { MenuService } from '@/layout/service/menu.service';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { COMISSOES_ROUTES, createComissoesMenu, TipoComissaoPessoa } from '@/features/comissoes/comissoes.constants';

@Component({
    selector: 'app-comissoes-content',
    standalone: true,
    imports: [RouterModule],
    template: `
        <main class="w-full">
            <div>
                <router-outlet></router-outlet>
            </div>
        </main>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ComissoesContent implements OnInit {
    private readonly menuService = inject(MenuService);
    private readonly route = inject(ActivatedRoute);
    private readonly destroyRef = inject(DestroyRef);

    ngOnInit(): void {
        // Sem isto o nome no topbar fica valendo o do último módulo aberto pelo lançador da
        // tela inicial: acesso direto ou recarga em rota interna mostrava outro módulo.
        this.menuService.setSistema('SICOM | Comissões e Câmaras Técnicas');

        this.route.paramMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
            const tipo: TipoComissaoPessoa = params.get('tipo') === COMISSOES_ROUTES.TIPO.ATIVIDADES ? COMISSOES_ROUTES.TIPO.ATIVIDADES : COMISSOES_ROUTES.TIPO.ACOMPANHAMENTO;
            this.menuService.setMenu(createComissoesMenu(tipo));
        });
    }
}
